import { ReactSVG } from 'react-svg';

import widthImg from 'images/width.svg';
import heightImg from 'images/height.svg';
import spaceaboveImg from 'images/spaceabove.svg';
import warningImg from 'images/warning.svg';

interface IconProps {
  icon: 'width' | 'height' | 'spaceabove' | 'warning' | string;
}

export const getIcon = (iconName: IconProps['icon']) => {
  switch (iconName) {
    case 'width':
      return <ReactSVG src={widthImg} />;
    case 'height':
      return <ReactSVG src={heightImg} />;
    case 'spaceabove':
      return <ReactSVG src={spaceaboveImg} />;
    case 'warning':
      return <ReactSVG src={warningImg} />;
    default:
      return iconName;
  }
};
